import React from 'react';
import Auth from '../../../routes/Auth';

export const handleSelectChange = (value, onSelectChange) => {
  Auth.setTeamId(value);

  onSelectChange();
}

export const arrayUniqueFilter = (value, index, self) => {
  return self.indexOf(value) === index;
}

export const formatMillionsValue = (value) => {
  let formattedValue = (value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
  return value < 0 ? <b>{formattedValue}</b> : formattedValue;
}


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/utils.js